// extracted by mini-css-extract-plugin
export default {"wrapper":"RA-z","viewport":"SA-z","container":"TA-z","slide":"UA-z"};